import { useSelector } from "react-redux";

import type { RootState } from "store";

export const useSelectUser = () =>
  useSelector((state: RootState) => state.auth.user);

export const useSelectIsAuthenticated = () =>
  useSelector((state: RootState) => !!state.auth.user);

export const useSelectUserRoles = () =>
  useSelector((state: RootState) => state.auth.user?.roles);
